<template>
  <v-container
    id="view-endpoint-single"
    fluid
    v-if="loaded"
  >
    <v-row>
      <v-col cols="12">
        <Breadcrumb :items="items"></Breadcrumb>
        <h1>{{ endpointData.name }}</h1>
      </v-col>



    </v-row>

    <v-row>
      <v-col cols="12" class="endpoint-overview">
        <v-row>
          <v-col
            cols="12"
            md="6"
            lg="3"
          >
            <v-card
              color="#5d3791"
              dark
            >
              <v-card-subtitle>Meters Available</v-card-subtitle>

              <v-card-title class="text-h5">
                {{ endpointData.meter_count }}
              </v-card-title>


            </v-card>
          </v-col>

          <v-col
            cols="12"
            md="6"
            lg="3"
          >
            <v-card
              :color="headerColor(endpointData.last_24_meter_reads)"
              dark
            >
              <v-card-subtitle>Reads (24 hours)</v-card-subtitle>

              <v-card-title class="text-h5">
                {{ endpointData.last_24_meter_reads }}
              </v-card-title>



            </v-card>
          </v-col>

          <v-col
            cols="12"
            md="6"
            lg="3"
          >
            <v-card
              :color="headerColor(endpointData.last_processed_at)"
              dark
            >
              <v-card-subtitle>Last Feed</v-card-subtitle>

              <v-card-title class="text-h5 smaller">
                <span v-if="endpointData.last_processed_at">{{ formatterDate(endpointData.last_processed_at) }}</span>
                <span v-else>-</span>
              </v-card-title>



            </v-card>
          </v-col>

          <v-col
            cols="12"
            md="6"
            lg="3"
          >
            <v-card
              color="#5d3791"
              dark
            >
              <v-card-subtitle>First Read Available</v-card-subtitle>

              <v-card-title class="text-h5">
                <span v-if="endpointData.first_read">{{ formatterDate(endpointData.first_read, true) }}</span>
                <span v-else>-</span>
              </v-card-title>



            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <h2>Meters</h2>

      </v-col>



      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
        <v-data-table
          :headers="headers"
          :items="endpointData.meters"
          :search="search"
          item-key="name"
          class="elevation-1"
        >
          <template #item.created_at="{ value }">
            <span>{{ formatterDate(value) }}</span>
          </template>
          <template #item.last_processed_at="{ value }">
            <span>{{ formatterDate(value) }}</span>
          </template>
          <template #item.read_value="{ value, item }">
            {{ value }}
            <v-icon
              right
              color="green"
              x-small
              v-if="item.is_valve && item.valve_state === true"
            >
              mdi-checkbox-blank-circle
            </v-icon>
            <v-icon
              right
              color="red"
              x-small
              v-if="item.is_valve && item.valve_state === false"
            >
              mdi-checkbox-blank-circle
            </v-icon>

          </template>
          <template #item.id="{ value }">

            <router-link
              custom v-slot="{ navigate }"
              :to="`/metering-data/${id}/meter/${value}`"
            >
              <button @click="navigate" role="link">
                <v-icon
                  right
                >
                  mdi-arrow-right-bold
                </v-icon>
              </button>
            </router-link
            >
          </template>
        </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <ExportEndpointData :id="id" :units="availableUnits"></ExportEndpointData>

  </v-container>
</template>

<script>
import {get} from "vuex-pathify";
import {date} from "@/mixins/date";
import Breadcrumb from "@/components/Breadcrumb";
import ExportEndpointData from "@/views/endpoints/components/ExportEndpointData";

export default {
  name: "EndpointSingle",
  props: {
    id: String
  },
  components: {
    ExportEndpointData,
    Breadcrumb
  },
  metaInfo () {
    return {
      title: this.endpointData.name
    }
  },
  computed: {
    endpointData: get('endpoints/endpoint'),
    endpointRef: get('endpoints/endpointRef'),
    endpointUpdated: get('endpoints/endpointUpdated'),
    items() {
      return [
        {
          text: 'Metering Data Overview',
          disabled: false,
          exact: true,
          to: '/metering-data',
        },
        {
          text: this.endpointData.name,
          disabled: true
        }
      ];
    }
  },
  mixins: [date],
  created() {
    this.$store.dispatch("loader/loaderCancel");
    this.fetchData();
  },
  data: () => ({
    loaded: false,
    search: '',
    availableUnits: [],
    headers: [
      {
        text: 'Meter Name',
        align: 'start',
        value: 'association_name',
      },
      {text: 'Serial', value: 'meter_reference'},
      {text: 'Alias', value: 'meter_alias'},
      {text: 'Unit', value: 'unit', filterable: false },
      {text: 'Created', value: 'created_at', filterable: false},
      {text: 'Last Read At', value: 'last_processed_at', filterable: false},
      {text: 'Last Read Value', value: 'read_value', filterable: false},
      {text: '', value: 'id', filterable: false},
    ],
  }),
  methods: {
    setExportMeterTypes() {
      const units = [...new Set(this.endpointData.meters.map(item => item.unit))];

      units.forEach(value => {
        this.availableUnits.push({
          value: value,
          text: value
        });
      });
    },
    headerColor(value) {
      if (!value || value === 0) {
        return '#FB8C00';
      }
      return '#5d3791';
    },
    async fetchData() {
      await this.$store.dispatch("loader/loaderInitiate", { title: "Loading Metering Data" });

      const success = await this.$store.dispatch("endpoints/getEndpoint", { endpointRef: this.id});
      if (!success) {
        await this.$router.push("/metering-data");
        return;
      }

      await this.$store.dispatch("loader/loaderCancel");

      this.setExportMeterTypes();

      this.loaded = true;
    },
    formatterDate(value, withoutTime) {
      if (!value) {
        return "";
      }
      return this.formatDate(value, true, !withoutTime);
    }
  }
}
</script>

<style lang="scss" scoped>
.endpoint-overview {
  .v-card__subtitle {
    padding-bottom: 0px;
    text-transform: uppercase;
    color: rgba(255,255,255,0.8);
  }
  .v-card__title {
    padding-top: 5px;
    font-size: 1.6rem !important;

    &.smaller {
      font-size: 1.4rem !important;
    }
  }
}

</style>
